<template>
  <v-dialog v-model="dialog" width="90%" scrollable persistent>
    <v-card>
      <v-card-title class="pa-0">
        <v-col cols="12" class="pa-0 text-right">
          <v-btn icon color="primary" @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" class="pa-0 text-center">
          <h1>Acompanhamento de Envio de Recursos</h1>
          <p>Itens da guia n° <b>{{ info.numero_guia_prestador }}</b></p>
        </v-col>
      </v-card-title>
      <v-card-text class="py-2 ">
        <v-row  class="px-1">
          <v-col cols="2">
            <span>Nº guia no prestador</span><br />
            <b>{{ info.numero_guia_prestador }}</b>
          </v-col>
          <v-col cols="2">
            <span>Protocolo Recursado</span><br />
            <b>{{ info.protocolo_recursado != null && info.protocolo_recursado != '' ? info.protocolo_recursado : info.numero_protocolo_demonstrado }}</b>
          </v-col>
          <v-col cols="2">
            <span>Nº do lote</span><br />
            <b>{{ info.numero_lote }}</b>
          </v-col>
          <v-col cols="2">
            <span>Carteirinha</span><br />
            <b>{{ info.carteira_beneficiario }}</b>
          </v-col>
          <v-col cols="4">
            <span>Beneficiário</span><br />
            <b>{{ info.nome_beneficiario }}</b>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="py-1 px-3">
            <v-form ref="addProtocoloLotesRecursadosForm">
              <v-row class="py-0 pl-2 pr-0">
              <v-col class="px-2 py-0" cols="2">
                <label>Status</label>
                <v-select
                  v-model="formData.status_envio"
                  :items="status"
                  item-value="id"
                  item-text="descricao"
                  :menu-props="{ bottom: true, offsetY: true }"
                  flat
                  solo
                  dense
                  outlined
                >
                <template v-slot:item="data">
                    <template v-if="(typeof data.item !=='object')">
                      <v-list-item-content v-text="data.item"></v-list-item-content>
                    </template>
                    <template v-else>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.descricao"></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-avatar size="14" :color="data.item.color" v-if="data.item.color">
                      </v-list-item-avatar>
                    </template>
                  </template>
                </v-select>
              </v-col>
              <v-col class="px-2 pt-5 align-right">
                <v-btn
                  style="margin-right: 16px !important"
                  small
                  height="32px"
                  color="primary"
                  class="px-2 mr-2"
                  depressed
                  @click="getList(formData, 1)"
                  >Filtrar</v-btn
                >
                <v-btn
                  outlined
                  small
                  height="32px"
                  color="primary"
                  class="px-2 ml-0"
                  depressed
                  @click="clearFilter()"
                  >Limpar Filtro</v-btn
                >
              </v-col>
              </v-row>
              <v-data-table
                dense
                :headers="headers"
                :items="itensList"
                hide-default-footer
              >
                <template class="center" v-slot:item.status="{ item }">
                  <v-tooltip center bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        class="icon_size"
                        style="font-size 15px"
                        v-bind="attrs"
                        v-on="on"
                        :color="getColor(item)"
                        >fa-circle</v-icon
                      >
                    </template>
                    <span
                      class="px-3 py-1 ma-0"
                      style="
                        border: solid 1px #999;
                        border-radius: 5px;
                        background-color: #fff;
                      "
                    >
                      {{getDescription(item)}}
                    </span>
                  </v-tooltip>
                  <!--
                  <v-tooltip
                      left
                      offset-x
                      :nudge-width="250"
                      max-width="250px"
                      v-if="item.status_envio == -1"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          icon
                          style="margin: 4px"
                          v-bind="attrs"
                          v-on="on"
                          small
                          color="error"
                          >fa-exclamation-triangle
                        </v-icon>
                      </template>
                        <span
                          class="px-3 py-1 ma-0"
                          style="
                            border: solid 1px #999;
                            border-radius: 5px;
                            background-color: #fff;
                          "
                          >{{ item.mensagens }}</span>
                    </v-tooltip>
                    -->
                    <v-spacer></v-spacer>
                    <!--<span v-html="getDescription(item).replace(' ', '<br>')"></span>-->
                </template>

                <template v-slot:item.data_execucao="{ item }" >
                  <b v-if="item.data_execucao">{{formatDate(item.data_execucao)}}</b>
                </template>
                <template v-slot:item.data_envio="{ item }" >
                  <b v-if="item.data_envio">{{formatDate(item.data_envio)}}</b>
                </template>
                <template v-slot:item.vl_glosado="{ item }">
                  <v-col v-if="item.valor_glosado != 0">
                    <b
                      ><span style="color: red"
                        >{{ item.valor_glosado | formatPrice }}</span
                      ></b
                    >
                  </v-col>
                </template>
                <template v-slot:item.vl_recursado="{ item }">
                  <v-col v-if="item.valor_recursado != 0">
                    <b
                      ><span style="color: rgb(50, 184, 139)">{{
                        item.valor_recursado | formatPrice
                      }}</span></b
                    >
                  </v-col>
                </template>
                <template v-slot:item.vl_acatado="{ item }">
                  <v-col v-if="item.valor_acatado != 0">
                    <b><span style="color: red"
                        >{{ item.valor_acatado | formatPrice }}</span
                      ></b>
                  </v-col>
                </template>
                <!-- <template v-slot:item.icons="{ item }">
                  <div style="white-space: nowrap; margin: 0; padding: 0"> -->
                    <!--
                    <v-tooltip
                      left
                      offset-x
                      :nudge-width="250"
                      max-width="250px"
                      v-if="item.status_envio == -1"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          icon
                          style="margin: 4px"
                          v-bind="attrs"
                          v-on="on"
                          small
                          color="error"
                          >fa-exclamation-triangle
                        </v-icon>
                      </template>
                      <v-card>
                        <v-card-text>
                          {{ item.mensagens }}
                        </v-card-text>
                      </v-card>
                    </v-tooltip> -->
                  <!-- </div>
                </template> -->
              </v-data-table>
              <template>
      <div style="margin-top: 30px" class="text-center py-0 col-md-12">
        <v-pagination
          class="no-box-shadow"
          v-model="page"
          :length="pagination.total_pages"
          @input="getList(formData, page)"
        ></v-pagination>
      </div>
    </template>
            </v-form>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="justify-center py-5">
        <v-btn
          color="primary"
          outlined
          height="30px"
          small
          depressed
          @click="close()"
          >Fechar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      formData: { status_envio: null },
      headers: [
        { text: "Status", align: "center", value: "status", sortable: false },
        { text: "Data de execução", align: "center", value: "data_execucao", sortable: false },
        { text: "Cód. Procedimento", align: "center", value: "codigo_procedimento", sortable: false },
        { text: "Procedimento/Despesa", value: "descricao_procedimento", sortable: false },
        //{ text: "Motivo recurso", align: "center", value: "motivo_glosa_recurso", sortable: false },
        { text: "Protocolo", align: "center", value: "numero_protocolo_envio", sortable: false },
        { text: "Data envio", align: "center", value: "data_envio", sortable: false },
        { text: "Retorno da Operadora", value: "mensagens", sortable: false },
        // { text: "Justificativa", value: "justificativa", sortable: false },
        // { text: "Qtde", align: "center", value: "quantidade", sortable: false },
        //{ text: "Vl. glosado (R$)", align: "center", value: "vl_glosado", sortable: false },
        { text: "Vl. recursado (R$)", align: "center", value: "vl_recursado", sortable: false },
        { text: "Vl. acatado (R$)", align: "center", value: "vl_acatado", sortable: false },
        //{ text: "", align: "center", value: "icons", sortable: false },
      ],
      numero_guia_prestador: null,
      page: 1,
      status: [],
      showProtocoloEnvioRecursoDlg: false
    };
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
      formRules: (state) => state.formRules
    }),
  },
  watch: {
    filterData: {
      deep: true,
      handler(val) {
         this.formData = {...val}
      }
    },
    pagination: {
      deep: true,
      handler(val){
        this.page = val.current_page
      }
    }
  },
  mounted() {
    //this.status = this.estadoList
    this.status = this.estadoList.filter(el=> el.id!=4)
  },
  props: {
    close: Function,
    dialog: Boolean,
    estadoList: Array,
    filterData: Object,
    getColor: Function,
    getDescription: Function,
    getList: Function,
    itensList: Array,
    info: Object,
    pagination: Object,
  },
  methods: {
    clearFilter() {
      this.formData.status_envio = null;
      this.getList(this.formData, 1);
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<style lang="scss">
.text-list {
  font-size: 13px;
  line-height: 1.15em;
}
.text-list.space {
  margin-right: 3px;
}
.text-list.pres {
  width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lotesRecursoTable.envio_manual {
  .v-data-table__wrapper > table > tbody > tr td:nth-child(5),
  .v-data-table__wrapper > table > tbody > tr td:nth-child(6) {
    background-color: rgba(207, 212, 3, 0.1) !important;
  }
}
.lotesRecursoTable {
  .v-data-table__wrapper > table > tbody > tr td:nth-child(6) {
    max-width: 150px;
  }
}
</style>